export enum SubsidiaryStatus {
	// Some creations steps have been validated but the subsidiary is not yet registered (= final step done).
	Draft = 'Draft',

	// The user have completed all the creation steps of a subsidiary and it's initialization is pending.
	Registered = 'Registered',

	// It's tenant has been created, it's database migrated, the admin created and it's ready to be used.
	Initialized = 'Initialized',

	// This subsidiary was started but the user forget it started a new draft. Poor little thing.
	Cancelled = 'Cancelled'
}
